import { buildQueryString, ServiceMaker } from ".";

export const createInvestor = (data: {
  contact: number;
  city: string;
  name: {
    fName: string;
    lName: string;
  };
  type: string;
  otp: number;
  remark: string;
}) => ServiceMaker("investor/create", "POST", data);

export const getInvestorsLeads = (data: {
  page: number;
  pageSize: number;
}) =>
  ServiceMaker(
    `investor/list?${buildQueryString(data)}`,
    "GET"
  );
